var e="\n#ifdef LIT_CLEARCOAT\nvoid addReflectionCC() {\n    ccReflection += calcReflection(ccReflDirW, ccGlossiness);\n}\n#endif\n";export{e as default};
